import { render } from "./qzfTabs.vue?vue&type=template&id=88d0c0fe&scoped=true"
import script from "./qzfTabs.vue?vue&type=script&lang=js"
export * from "./qzfTabs.vue?vue&type=script&lang=js"

import "./qzfTabs.vue?vue&type=style&index=0&id=88d0c0fe&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88d0c0fe"]])

export default __exports__